import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import LinearProgress from 'Components/UI/LinearProgress';
import { getUploadText } from 'Helpers/File';

import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import { FDSecondaryActionButton, FDStack } from '@facet-wealth/design';
import SecureFilesUploader from './Uploader';

const useStyles = buildUseStyles('HeaderNew', () => ({
  progressBar: {
    width: '100%',
  },
  buttonHolderHidden: {
    display: 'none',
  },
}));

const HeaderNew = (props) => {
  const {
    openFolderModal,
    setUploadProgress,
    uploadProgress,
    handleSuccessfulUpload,
    folderId,
    householdId,
  } = props;

  const classes = useStyles();

  const isUploading = uploadProgress != null;

  return (
    <PageHeader
      title="Files"
      subtitle="Manage your secure files and folders."
      actions={isUploading ? (
        <LinearProgress
          className={classes.progressBar}
          visible
          text={getUploadText(uploadProgress)}
          ProgressProps={{
            color: 'secondary',
            value: uploadProgress,
            variant: 'determinate',
          }}
        />
      ) : (
        <FDStack spacing={2} wrap>
          <SecureFilesUploader
            folderId={folderId}
            householdId={householdId}
            onSuccess={handleSuccessfulUpload}
            setUploadProgress={setUploadProgress}
          >
            <FDSecondaryActionButton icon="upload" label="Upload Document" />
          </SecureFilesUploader>
          {openFolderModal && <FDSecondaryActionButton icon="add" onClick={openFolderModal} label="New Folder" />}
        </FDStack>
      )}
    />
  );
};

HeaderNew.defaultProps = {
  openFolderModal: undefined,
};

HeaderNew.propTypes = {
  openFolderModal: PropTypes.func,
  setUploadProgress: PropTypes.func.isRequired,
  uploadProgress: PropTypes.number.isRequired,
  handleSuccessfulUpload: PropTypes.func.isRequired,
  folderId: PropTypes.number.isRequired,
  householdId: PropTypes.number.isRequired,
};

export default HeaderNew;
